import projectImage from '../public/images/project.png'
import PIET from '../public/images/project_image/PIET.png'
import medtech from '../public/images/project_image/medtech.png'
import sgpa from '../public/images/project_image/sgpa.png'
import diabities from '../public/images/project_image/diabities.png'
import portfolio from '../public/images/project_image/portfolio.png'

export const projects = [
    {
      title: "All Projects",
      links: [
        {
          title: "PIET, Jaipur Website",
          image: PIET,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/college_website',
          projectLink: 'http://www.piet.poornima.org/'

        },
        {
          title: "StudyNotion",
          image: projectImage,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: '',
          projectLink: ''
        },
        {
          title: "MedTech",
          image: medtech,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/MedTech',
          projectLink: ''
        },
        {
          title: "SGPA Calculator",
          image: sgpa,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/SGPA_Calculator-using-React',
          projectLink: 'https://sgpa-calculator-using-react.vercel.app/'
        },
        {
          title: "Portfolio Website",
          image: portfolio,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/portfolio',
          projectLink: 'https://portfolio-dev-tekwani.vercel.app/'
        },
        {
          title: "Diabities Prediction",
          image: diabities,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/Diabities_prediction_model',
          projectLink: 'diabitiespredictionwebapp.streamlit.app/'
        },
      ]

    },
    {
      title: "Web Projects",
      links: [
        {
          title: "PIET, Jaipur Website",
          image: PIET,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/college_website',
          projectLink: 'http://www.piet.poornima.org/'

        },
        {
          title: "StudyNotion",
          image: projectImage,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: '',
          projectLink: ''
        },
        {
          title: "SGPA Calculator",
          image: sgpa,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/SGPA_Calculator-using-React',
          projectLink: 'https://sgpa-calculator-using-react.vercel.app/'
        },
        {
          title: "Portfolio Website",
          image: portfolio,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/portfolio',
          projectLink: 'https://portfolio-dev-tekwani.vercel.app/'
        },
        
      ],
    },
    {
      title: "ML projects",
      links: [
        {
          title: "MedTech",
          image: medtech,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/MedTech',
          projectLink: ''
        },
        {
          title: "Diabities Prediction",
          image: diabities,
          description: 'In a world where technology evolves rapidly, staying ahead means constantly learning and adapting. Embracing change is no longer optional but essential for success. The fusion of innovation and creativity drives progress, pushing boundaries and creating new possibilities.',
          githubLink: 'https://github.com/Devtekwani09/Diabities_prediction_model',
          projectLink: 'diabitiespredictionwebapp.streamlit.app/'
        },
      ],
    },
  ];
  